import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
  Description,
} from "@headlessui/react";

const ModalTemplate = ({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  showCloseButton = true,
  maxWidth = "lg", // sm, md, lg, xl, 2xl, etc.
}) => {
  // if (!isOpen) return null;

  return (
    <Dialog
      open={isOpen}
      onClose={showCloseButton ? onClose : () => {}}
      className="relative z-50"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-lightGray/95 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className={`relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-${maxWidth} data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              {title && (
                <DialogTitle
                  as="h3"
                  className="text-base font-semibold text-gray-900 font-sans mb-4"
                >
                  {title}
                </DialogTitle>
              )}
              {subtitle && (
                <Description
                  as="h4"
                  className="text-sm font-normal text-gray-500 font-sans mb-4"
                >
                  {subtitle}
                </Description>
              )}
              {children}
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

ModalTemplate.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  showCloseButton: PropTypes.bool,
  maxWidth: PropTypes.string,
};

export default ModalTemplate;
